import { useCallback } from "react";
import { useErrorHandler } from "../state/useErrorHandler.js";
import { baseBackendURL } from "../../helpers/baseUrl.js";

export const useSubscriptionActions = () => {
  const { handleUserError } = useErrorHandler();

  const manageSubscription = useCallback(async () => {
    try {
      const response = await fetch(`${baseBackendURL}/stripe/customer-portal`, {
        method: "GET",
        credentials: "include",
      });
      const data = await response.json();

      if (data.success && data.url) {
        window.location.href = data.url;
      } else {
        throw new Error(data.message || "Failed to get customer portal URL");
      }
    } catch (error) {
      handleUserError(error);
      throw error;
    }
  }, [handleUserError]);

  return {
    manageSubscription,
  };
};
